import { SxProps, Theme } from '@mui/material/styles';

import { TABLE_HEADER_HEIGHT } from './constants';

// Base styles shared between field and page tables
const baseDataGridStyles = {
  main: {
    minWidth: 0,
    padding: 0,
    borderRadius: '8px',
  },
  virtualScroller: {
    borderRadius: 0,
  },
  toolbar: {
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    pl: 1,
    pr: 2,
    minHeight: 48,
  },
};

export const objectListContainerStyles: SxProps<Theme> = {
  display: 'grid',
  minWidth: 0,
  height: `calc(100dvh - ${TABLE_HEADER_HEIGHT}px)`,
  gridRowGap: 2,
  // The third row provides extra space to ensure that when the object list doesn't contain enough rows to fill the height of the page,
  // it doesn't take up the entire height of the page.
  gridTemplateRows: 'auto auto 1fr',
};

// Styles for data grids inside form fields - e.g. UserOrRolePermissionsTable.
export const fieldDataGridStyles: SxProps<Theme> = {
  '& .MuiDataGrid-main': {
    ...baseDataGridStyles.main,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    border: (theme) => `0.5px solid ${theme.palette.grey30}`,
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-virtualScroller': {
    ...baseDataGridStyles.virtualScroller,
    borderTop: (theme) => `0.5px solid ${theme.palette.grey30}`,
    borderLeft: 0,
    borderRight: 0,
    borderBottom: 0,
  },
  '& .MuiToolbar-root': {
    ...baseDataGridStyles.toolbar,
    borderLeft: (theme) => `0.5px solid ${theme.palette.grey30}`,
    borderRight: (theme) => `0.5px solid ${theme.palette.grey30}`,
    borderBottom: (theme) => `0.5px solid ${theme.palette.grey30}`,
  },
};

// Styles for data grids inside pages - e.g. UsersTable or RolesTable.
export const pageDataGridStyles: SxProps<Theme> = {
  '& .MuiDataGrid-main': {
    ...baseDataGridStyles.main,
    backgroundColor: (theme) => theme.palette.grey05,
    border: (theme) => `thin solid ${theme.palette.grey20}`,
  },
  '& .MuiDataGrid-virtualScroller': {
    ...baseDataGridStyles.virtualScroller,
    outline: (theme) => `thin solid ${theme.palette.grey20}`,
    border: 0,
    borderRadius: '8px',
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: (theme) => theme.palette.grey05,
  },
  '& .MuiToolbar-root': {
    ...baseDataGridStyles.toolbar,
    borderLeft: (theme) => `thin solid ${theme.palette.grey20}`,
    borderRight: (theme) => `thin solid ${theme.palette.grey20}`,
    borderBottom: (theme) => `thin solid ${theme.palette.grey20}`,
    pt: 1,
    marginTop: -1,
    height: 56,
  },
  '& .MuiTablePagination-root': {
    borderTop: 0,
    '& .MuiTablePagination-select': {
      fontSize: '14px',
    },
    '& .MuiTablePaginationActions-root': {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    '& .MuiButtonBase-root': {
      color: (theme) => theme.palette.grey70,
      '&.Mui-disabled': {
        opacity: 0.5,
      },
      '& .MuiSvgIcon-root': {
        height: '24px',
        width: '24px',
      },
    },
  },
};
